module.exports = ['$scope', 'curriculumManager', 'bibContentManager', '$stateParams', '$state', 'sriClient', '$document', '$window', 'settings', 'ngMeta', '$location',
  function ($scope, CurriculumManager, bibContentManager, $stateParams, $state, sriClient, $document, $window, settings, ngMeta, $location) {
    'use strict';
    $scope.$parent.hideSearchBar = true;
    $scope.attachments = [];
    $scope.links = [];
    $scope.footnotes = [];

    var offset = 105;
    function elmYPosition (eID) {
      var elm = document.getElementById(eID);
      if (! elm) {
        console.warn(eID + ' is not found');
      } else {
        var y = elm.offsetTop;
        var node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
          node = node.offsetParent;
          y += node.offsetTop;
        }
        return y;
      }
    }
    function elmYEndPosition (eID) {
      var elm = document.getElementById(eID);
      if (! elm) {
        console.warn(eID + ' is not found');
      } else {
        var y = elm.offsetTop + elm.offsetHeight;
        var node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
          node = node.offsetParent;
          y += node.offsetTop;
        }
        return y;
      }
    }


    var cachedHeight = 0;

    var scollListner = function (e) {
      var viewItem = $scope.content;
      if ($scope.content && $scope.content.contents) {
        viewItem.contents.filter(o => o.type === 'SECTION').forEach(function (content) {
          content.prevPosition = elmYPosition(content.key) - 1;
          content.nextPosition = elmYEndPosition(content.key);
        });

        const position = $window.scrollY;
        if (viewItem && viewItem.contents) {
          $scope.selected = viewItem.contents.filter(function (o) {
            return o.prevPosition < position + offset && o.nextPosition > position + offset && o.type === 'SECTION';
          })[0];

          if ($scope.selected) {
            $scope.selected = $scope.selected.key;
          }

          if($scope.attachments && $scope.attachments.length > 0 && elmYEndPosition('downloads') > position + offset && elmYPosition('downloads') < position + offset) {
            $scope.current = 'downloads';
            $scope.selected = null;
          } else if($scope.content.contents.length > 0 && elmYEndPosition('verloop') > position + offset && elmYPosition('verloop') < position + offset) {
            $scope.current = 'verloop';
          } else if(elmYEndPosition('doelen') > position + offset && elmYPosition('doelen') < position + offset) {
            $scope.current = 'doelen';
            $scope.selected = null;
          } else if($scope.links && $scope.links.length > 0 && elmYEndPosition('links') > position + offset && elmYPosition('links') < position + offset) {
            $scope.current = 'links';
            $scope.selected = null;
          } else if($scope.content.sources && $scope.content.sources.length > 0 && elmYEndPosition('bronnen') > position + offset && elmYPosition('bronnen') < position + offset) {
            $scope.current = 'bronnen';
            $scope.selected = null;
          } else {
            $scope.current = null;
            $scope.selected = null;
          }
          //$scope.$apply();
        }
      }
    };

    $document.on('scroll', scollListner);

    $scope.$on('$destroy', function () {
      $document.off('scroll', scollListner);
    });

    var getGoalBySelection = function (item) {
      var foundGoal;
      if (item) {
        if (item.type === 'CURRICULUM_ZILL_GENERIC_GOAL') {
          foundGoal = _.clone(item);
        } else if (item.type === 'CURRICULUM_ZILL_LEERLIJN_CLUSTER') {
          if (item.leerlijn.parentName === 'content2') {
            foundGoal = _.clone(item.leerlijn.content2.content1.contentGroup.goal);
            if (!foundGoal.content2LeerlijnRef) {
              foundGoal.content2LeerlijnRef = [];
            }
            foundGoal.content2LeerlijnRef.push(item);
          } else if (item.leerlijn.parentName === 'content1') {
            foundGoal = _.clone(item.leerlijn.content1.contentGroup.goal);
            if (!foundGoal.content1LeerlijnRef) {
              foundGoal.content1LeerlijnRef = [];
            }
            foundGoal.content1LeerlijnRef.push(item);
          } else {
            foundGoal = _.clone(item.leerlijn.goal);
            if (!foundGoal.leerlijnRef) {
              foundGoal.leerlijnRef = [];
            }
            foundGoal.leerlijnRef.push(item);
          }
        } else if (item.type === 'CURRICULUM_ZILL_DEVELOPMENT_CONTENT') {
          if (item.parentName === 'content1') {
            foundGoal = _.clone(item.content1.contentGroup.goal);
            if (!foundGoal.content2Ref) {
              foundGoal.content2Ref = [];
            }
            foundGoal.content2Ref.push(item);
          } else {
            foundGoal = _.clone(item.contentGroup.goal);
            if (!foundGoal.content1Ref) {
              foundGoal.content1Ref = [];
            }
            foundGoal.content1Ref.push(item);
          }
        }
      }
      return foundGoal;
    };

    $scope.loadingGoals = true;
    $scope.loading = true;
    bibContentManager.getContent('/content/' + $stateParams.key).then(function (result) {
      $scope.content = result;
      ngMeta.setTitle(result.title);
      ngMeta.setTag('description', result.description);
      if(result.thumbnail && result.thumbnail.href.indexOf('undefined') == -1) {
        result.thumb = settings.apisAndUrls.cachedApi + result.thumbnail.href;
        ngMeta.setTag('image', result.thumb);
      }
      $scope.loading = false;

      //ILLUSTRATIONS
      var illustrations = result.$$relationsTo
        .filter(o => o.$$expanded.relationtype === 'REFERENCES')
        .map(o => o.$$expanded.from.href);
      var illustrationPromises = [];
      $scope.selections = [];
      
      if (!illustrations.length) {
        $scope.loadingGoals = false;
      }
      const baseUrl = $location.search().preview ? settings.apisAndUrls.api : settings.apisAndUrls.cachedApi;
      _.chunk(illustrations, 20).forEach(function (chunk) {
        illustrationPromises.push(sriClient.getAll('/content', {hrefs: chunk.join(), type: 'ZILL_ILLUSTRATION'}, {baseUrl}).then(function (results) {
          results.forEach(function (result) {
            result.$$relationsFrom.filter(o => o.$$expanded.relationtype === 'REFERENCES').forEach(function (illustrationRelation) {
              CurriculumManager.getByHref(illustrationRelation.$$expanded.to.href).then(function (selection) {
                if(selection) {
                  const goal = getGoalBySelection(selection);
                  const existingGroup = $scope.selections.find((group) => group.code === goal.code );
                  const subtitle = {
                    age: selection.startage && selection.endage ? `${selection.startage}-${selection.endage}j` : null,
                    text: (selection.content1 ? `${selection.content1.title} ->` : '') + (selection.title || selection.description)
                  };

                  if(!existingGroup) {
                    $scope.selections.push({
                      goal,
                      subgoals: selection.type === 'CURRICULUM_ZILL_GENERIC_GOAL' ? [] : [subtitle],
                      illustration: result,
                      code: goal.code
                    });
                  } else if(subtitle && selection.type !== 'CURRICULUM_ZILL_GENERIC_GOAL') {
                    existingGroup.subgoals.push(subtitle);
                  }
                }
                $scope.loadingGoals = false;
              }, function () {
                $scope.loadingGoals = false;
              });
            });
          });
        }));
      });

      //LINKS
      $scope.links = result.links;

      $scope.attachments = result.attachmentsOfDocument;
      scollListner();
    }, function () {
      $state.go('notFound', {}, { location: false });
    });

    $scope.goLevel1 = function (key) {
      window.scrollTo(0, elmYPosition(key) - offset + 1);
    };

    $scope.footnotes = [];
    var footnotes = [];
    $scope.replaceRef = function (html) {
      html.match(/<a.*href=".*(\/content\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}).*".*rel="footnote".*>\[(.*)\]<\/a>/g).forEach(function (matchItem) {
        var footnote = (/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/).exec(matchItem);
        footnotes.push($scope.$parent.find(footnote[1]));
      });
      footnotes = _.uniq(footnotes);
      $scope.footnotes = footnotes;
      return html.replace(/<a.*href=".*(\/content\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}).*".*rel="footnote".*>\[(.*)\]<\/a>/g, "<sup>$2</sup>")
    };

  }
];



// WEBPACK FOOTER //
// ./web/js/screen/bib/display/bibDisplayController.js